import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import ListComponent from "@/components/listComponent"
import { MyContext } from "@/store/myContext"
import Detail from "./detail"
import { paymentRefundList, paymentRefundSync } from "@/service/ordersService"
import TopSearch from "@/components/TopSearch"
import { Select } from "antd"
const { Option } = Select

//访问列表
export default () => {
    
    const { t } = useTranslation();
    const { state, message } = useContext(MyContext)
    const [showVisible, setShowVisible] = useState(false)
    const [showMode, setShowMode] = useState("")
    const [list, setList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })
    const [selectInfo, setSelectInfo] = useState({ rowInfo: {}, rowIndex: -1 }) //记录当前行下标及信息
    const [loading, setLoading] = useState(false)
    const StatusObj = {
        unpaid: t(`ordersManage.refundedOrder.refundedOrder.未支付`),
        paid: t(`ordersManage.refundedOrder.refundedOrder.已支付`),
        refunding: t(`ordersManage.refundedOrder.refundedOrder.退款中`),
        wx_refunding: t(`ordersManage.refundedOrder.refundedOrder.微信退款中`),
        refunded: t(`ordersManage.refundedOrder.refundedOrder.已退款`),
        refund_reject: t(`ordersManage.refundedOrder.refundedOrder.退款驳回`),
    }
    useEffect(() => {
        if (state.activeMenu === "refundedOrder") {
            loadData(pagination.current)
        }
    }, [state.activeMenu]) // eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = (current, search = {}) => {
        setLoading(true)
        let data = {
            searchItem: { disableFlag: 0, ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
        }
        paymentRefundList(data).then((res) => {
            setpagination({
                current: current,
                total: res.retData.total,
                pageSize: 10,
            })
            setSelectInfo({ rowInfo: {}, rowIndex: -1 })
            setList(res.retData.list)
        }).finally(res => {
            setLoading(false)
        })
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    const refundSync = () => {
        if (!selectInfo.rowInfo.id) {
            message.warning(t(`ordersManage.refundedOrder.refundedOrder.请选择你要同步的工单`))
            return
        }
        const {orderId,id: orderPaymentRefundId} = selectInfo.rowInfo
        paymentRefundSync({orderId,orderPaymentRefundId}).then(res => {
            message.success(t(`ordersManage.refundedOrder.refundedOrder.同步成功`))
            loadData(pagination.current)
        })
    }
    //列表button
    const topButtons = [
        {
            click: () => handleDetails("edit"),
            content: t(`ordersManage.refundedOrder.refundedOrder.编辑`),
        },
        {
            click: () => refundSync (),
            content: t(`ordersManage.refundedOrder.refundedOrder.同步`),
        },
    ]

    //新增
    const handleDetails = async (mode) => {
        if (mode === "edit") {
            if (!Object.keys(selectInfo.rowInfo).length) {
                message.warning(t(`ordersManage.refundedOrder.refundedOrder.请选择你要编辑的工单`))
                return
            }
        }
        setShowMode(mode)
        setShowVisible(true)
    }

    //table配置
    const columns = [
        {
            title: t(`ordersManage.refundedOrder.refundedOrder.工单编号`),
            align: "center",
            dataIndex: "orderCode",
        },
        {
            title: t(`ordersManage.refundedOrder.refundedOrder.退款单号`),
            align: "center",
            dataIndex: "code",
        },
        {
            title: t(`ordersManage.refundedOrder.refundedOrder.退款金额`),
            align: "center",
            dataIndex: "refundAmount",
        },
        {
            title: t(`ordersManage.refundedOrder.refundedOrder.服务类型`),
            align: "center",
            dataIndex: "link",
            render: (text) =>  {t(`ordersManage.refundedOrder.refundedOrder.取消工单`)},
        },
        {
            title: t(`ordersManage.refundedOrder.refundedOrder.申请时间`),
            align: "center",
            dataIndex: "applicantTime",
        },
        {
            title: t(`ordersManage.refundedOrder.refundedOrder.状态`),
            align: "center",
            dataIndex: "status",
            render: (text) => StatusObj[text],
        },
    ]
    // 搜索JSON
    const searchList = {
        normalList: [
            {
                type: "input",
                placeholder: t(`ordersManage.refundedOrder.refundedOrder.请输入工单编号`),
                valueName: "orderCode",
            },
            {
                type: "select",
                placeholder: t(`ordersManage.refundedOrder.refundedOrder.状态`),
                valueName: "status",
                optionList: () =>
                    Object.entries(StatusObj).map((item) => (
                        <Option value={item[0]} key={item[0]}>
                            {item[1]}
                        </Option>
                    )),
            },
            {
                type: "RangePicker",
                valueName: ["startTime", "endTime"],
                span: 16,
                xxl: 8,
            },
        ],
    }

    return (
        <>
            {state.activeMenu === "refundedOrder" && (
                <>
                    <TopSearch
                        title= {t(`ordersManage.refundedOrder.refundedOrder.退款工单`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent
                        title= {t(`ordersManage.refundedOrder.refundedOrder.退款工单`)}
                        buttons={topButtons}
                        selectInfo={selectInfo}
                        columns={columns}
                        dataSource={list}
                        pagination={pagination}
                        onTableChange={onTableChange}
                        setSelectInfo={(obj) => setSelectInfo(obj)}
                        scroll={{ x: "max-content" }}
                        loading={loading}
                    />

                    {showVisible && (
                        <Detail
                            rowInfo={selectInfo.rowInfo}
                            StatusObj={StatusObj}
                            visible={showVisible}
                            mode={showMode}
                            setVisible={setShowVisible}
                            onSuccess={() => {
                                loadData(1, searchValue)
                            }}
                        />
                    )}
                </>
            )}
        </>
    )
}
